import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DIGITAL_UI } from "../theme";
import { AppBar, Link, Button } from "@material-ui/core";
import { useAuth0 } from "@auth0/auth0-react";

import config from "../config";

const useStyles = makeStyles((theme) => ({
  root: {
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    background: DIGITAL_UI.header || `#FFFFFF`,
    height: 120,
    width: "100vw",
    position: "fixed",
    padding: [[0, 20]],
    borderBottom: "1px solid #CBC5BE",
    boxShadow: "none"
  },
  logo: {
    marginTop:"24px",
    marginLeft: "58px",
    background:"url('https://d2xu8aednu6tgg.cloudfront.net/assets/images/php_myprov_logo.svg')",
    width: "512px",
    height: "75px",
    cursor: "pointer",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left center",
    "@media only screen and (max-width: 650px)": {
      marginLeft: "0"
    },
  },
  button: {
    "@media only screen and (max-width: 650px)": {
      height: 35,
      width: "fit-content",
    },
  },
}));

const Masthead = () => {
  const classes = useStyles();
  const { isAuthenticated, logout } = useAuth0();

  return (
    <AppBar
      className={classes.root}
      id="masthead"
      position="static"
      elevation={3}
      square
    >
      {/* <Link className={classes.logo} variant="inherit" color={'inherit'} target='_blank' rel='noreferrer' href='#' aria-label='consumer logo'> </Link> */}

      <Link 
        style={{display:"flex", flexDirection:"row"}}
        variant="inherit"
        color={"inherit"}
        rel="noreferrer"
        href="/profile"
        aria-label="consumer logo"   
        className={classes.logo}
      />
      {isAuthenticated && (
        <Button
          variant="contained"
          className={classes.button}
          onClick={() =>
            logout({ logoutParams: { returnTo: config.myProvSamlUrl } })
          }
        >
          Log out
        </Button>
      )}
    </AppBar>
  );
};

export default Masthead;
